export enum CustomActionCardMenuActionType {
  CreateCategory,
  EditCategory,
  AddService,
  DeleteCategory,
  MoveService,
  AssignCategory,
}
